export const addBulletinURL = 'https://us-central1-benefits-law-group-of-chicago.cloudfunctions.net/api'//URL for add bulletin cloud function